import { render } from "./SocialMediaSharing.vue?vue&type=template&id=008d8f05&scoped=true"
import script from "./SocialMediaSharing.vue?vue&type=script&lang=js"
export * from "./SocialMediaSharing.vue?vue&type=script&lang=js"

import "./SocialMediaSharing.vue?vue&type=style&index=0&id=008d8f05&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-008d8f05"

export default script